import axios from "axios";
import { API_BASE } from "../../config/env";
export const FETCH_ASSIGNAPPLICATION_FULFILLED = "FETCH_ASSIGNAPPLICATION_FULFILLED";
export const FETCH_ASSIGNAPPLICATION_REJECTED = "FETCH_ASSIGNAPPLICATION_REJECTED";
export const FETCH_ASSIGNAPPLICATION_PENDING = "FETCH_ASSIGNAPPLICATION_PENDING";
export const RESET = "RESET"

export function assignApplication(applicationId,careProviderId,role) {
    const token = localStorage.getItem("accessToken")

    return dispatch => {
        dispatch({
          type: "FETCH_ASSIGNAPPLICATION",
          payload: axios({
            method: "post",
            url: `${API_BASE}/api/v2/second-opinion/assignment/`+applicationId+"/"+careProviderId+"/"+role,
            headers: {
                "Authorization": "Bearer " + token,
                "Accept-Language": "tr-tr",
                "Client-Id": localStorage.getItem("One-Id"),
                "One-Id": localStorage.getItem("Client-Id"),
                "Content-Type": "application/json",
                "ngrok-skip-browser-warning" : "69920"
            },
          }).then((result) => result.data),
        });
      };
}


export function resetAssignApplication() {
  return (dispatch) => {
      dispatch({
          type: "RESET",
      });
  };
}


